<template>
    <div class="message"
         :class="{'message-error': (status === 'error'), 'message-success': (status === 'success'), 'message-generic': (status === 'generic')}">
        <img v-if="status === 'error'" src="../../images/icons/msg-error.svg">
        <img v-if="status === 'generic' && onFootballerLivesPage" src="../../images/icons/msg-generic-black.svg">
        <img v-if="status === 'generic' && !onFootballerLivesPage" src="../../images/icons/msg-generic.svg">
        <img v-if="status === 'success'" src="../../images/icons/msg-success.svg">
        <p>{{ message }}</p>
    </div>
</template>

<script>
    export default {
        props: ['status', 'message', 'onFootballerLivesPage'],
    }
</script>
